import {command, queryOne, querySearch} from "../utils/api";

const GET_BULK_CONSIGNMENTS_URL = `${process.env.PUBLIC_URL}/api/v1/r/bulkConsignments`;

export const SEARCH_BULK_CONSIGNMENTS = 'SEARCH_BULK_CONSIGNMENTS';
export const SEARCH_BULK_CONSIGNMENTS_COMPLETED = 'SEARCH_BULK_CONSIGNMENTS_COMPLETED';
export const SEARCH_BULK_CONSIGNMENTS_FAILED = 'SEARCH_BULK_CONSIGNMENTS_FAILED';
export const searchBulkConsignments = querySearch(GET_BULK_CONSIGNMENTS_URL, SEARCH_BULK_CONSIGNMENTS, SEARCH_BULK_CONSIGNMENTS_COMPLETED, SEARCH_BULK_CONSIGNMENTS_FAILED,
  ['bulkProductName', 'lotNumber', 'bulkProductUnitOfMeasureClass', 'receivedUnit'], {defaultOrder: 'remainingQuantity DESC'});

export const GET_BULK_CONSIGNMENT = 'GET_BULK_CONSIGNMENT';
export const GET_BULK_CONSIGNMENT_COMPLETED = 'GET_BULK_CONSIGNMENT_COMPLETED';
export const GET_BULK_CONSIGNMENT_FAILED = 'GET_BULK_CONSIGNMENT_FAILED';
export function getBulkConsignment({bulkConsignmentId}) {
  return queryOne(GET_BULK_CONSIGNMENTS_URL, {where: {bulkConsignmentId}}, GET_BULK_CONSIGNMENT, GET_BULK_CONSIGNMENT_COMPLETED, GET_BULK_CONSIGNMENT_FAILED);
}

const BULK_CONSIGNMENT_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/bulkConsignment`;
export const RECEIVE_BULK_PRODUCT = 'RECEIVE_BULK_PRODUCT';
export const RECEIVE_BULK_PRODUCT_COMPLETED = 'RECEIVE_BULK_PRODUCT_COMPLETED';
export const RECEIVE_BULK_PRODUCT_FAILED = 'RECEIVE_BULK_PRODUCT_FAILED';
export const receiveBulkProduct = command(BULK_CONSIGNMENT_ACTION_URL + '/receiveBulkProduct', RECEIVE_BULK_PRODUCT, RECEIVE_BULK_PRODUCT_COMPLETED, RECEIVE_BULK_PRODUCT_FAILED);

export const UPDATE_RECEIVED_BULK_PRODUCT = 'UPDATE_RECEIVED_BULK_PRODUCT';
export const UPDATE_RECEIVED_BULK_PRODUCT_COMPLETED = 'UPDATE_RECEIVED_BULK_PRODUCT_COMPLETED';
export const UPDATE_RECEIVED_BULK_PRODUCT_FAILED = 'UPDATE_RECEIVED_BULK_PRODUCT_FAILED';
export const updateReceivedBulkProduct = command(BULK_CONSIGNMENT_ACTION_URL + '/updateReceivedBulkProduct',
  UPDATE_RECEIVED_BULK_PRODUCT, UPDATE_RECEIVED_BULK_PRODUCT_COMPLETED, UPDATE_RECEIVED_BULK_PRODUCT_FAILED);

export const RECORD_BULK_PRODUCT_WASTE = 'RECORD_BULK_PRODUCT_WASTE';
export const RECORD_BULK_PRODUCT_WASTE_COMPLETED = 'RECORD_BULK_PRODUCT_WASTE_COMPLETED';
export const RECORD_BULK_PRODUCT_WASTE_FAILED = 'RECORD_BULK_PRODUCT_WASTE_FAILED';
export const recordBulkProductWaste = command(BULK_CONSIGNMENT_ACTION_URL + '/recordBulkProductWaste',
  RECORD_BULK_PRODUCT_WASTE, RECORD_BULK_PRODUCT_WASTE_COMPLETED, RECORD_BULK_PRODUCT_WASTE_FAILED);

const PRODUCT_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/product`;
export const PACKAGE_PRODUCT = 'PACKAGE_PRODUCT';
export const PACKAGE_PRODUCT_COMPLETED = 'PACKAGE_PRODUCT_COMPLETED';
export const PACKAGE_PRODUCT_FAILED = 'PACKAGE_PRODUCT_FAILED';
export const packageProduct = command(PRODUCT_ACTION_URL + '/packageProduct', PACKAGE_PRODUCT, PACKAGE_PRODUCT_COMPLETED, PACKAGE_PRODUCT_FAILED);



// WEBPACK FOOTER //
// ./src/BulkConsignment/actions.js